import { render } from "./News.vue?vue&type=template&id=7f95d178&scoped=true&ts=true"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=7f95d178&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f95d178"]])

export default __exports__